import React from "react";
import { FaAward } from "react-icons/fa";
import { VscFolderLibrary } from "react-icons/vsc";
import ME from "../../assets/avatar.jpg";
import "./intro.css";

const Intro = ({ setActiveNav }) => {
    return (
        <section id="about">
            <h5>Get to know</h5>
            <h2>About Me</h2>
            <div className="container about__container">
                <div className="about__me">
                    <div className="about__me-image">
                        <img src={ME} alt="me" />
                    </div>
                </div>
                <div className="about__content">
                    <div className="about__cards">
                        <article className="about__card">
                            <FaAward className="about__icon" />
                            <h5>Experience</h5>
                            <small>4 year</small>
                        </article>
                        <article className="about__card">
                            <VscFolderLibrary className="about__icon" />
                            <h5>Projects</h5>
                            <small>50+ Completed Projects</small>
                        </article>
                    </div>
                    <p>
                        &nbsp;&nbsp;&nbsp;&nbsp; I'm a Full-Stack Web Developer
                        with 4+ years of freelance experience building landing
                        pages, React applications, and custom email templates. I
                        specialize in translating Figma designs into clean,
                        accessible code and delivering polished results on
                        platforms like WordPress, Webflow, and Shopify.
                        <br />
                        <br />
                        Before switching to web development, I spent over 10
                        years as a design engineer, which gave me a strong eye
                        for detail and a systems-thinking approach to every
                        project. I'm also experienced with MJML email templates
                        and have worked with enterprise tools including
                        Microsoft SharePoint.
                    </p>
                    <div className="about__btn-box">
                        <a
                            href="#contact"
                            className="btn btn-primary"
                            onClick={() => setActiveNav("#contact")}>
                            Let's Talk
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Intro;
